export default __webpack_public_path__ + "static/media/Mentionslegales.9c5f27ae.pdf";